import { ZoomMtg } from "@zoomus/websdk";
import React from "react";
import { getDecodedDataFromWebinarLink } from "./ZoomUtils";
import { IWebinarTokenPayload } from "./interfaces";
import { APP_BASE_URL } from "../../constants/Configs";
import "./ZoomPage.css";
ZoomMtg.setZoomJSLib("https://source.zoom.us/2.17.0/lib", "/av");
ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();
ZoomMtg.i18n.load("en-US");
ZoomMtg.i18n.reload("en-US");

function ZoomPage() {
  const meetingObj: IWebinarTokenPayload = getDecodedDataFromWebinarLink(
    window.location.href
  );
  const signature = meetingObj.signature || "";
  const sdkKey = meetingObj.sdkKey || "";
  const passWord = meetingObj.passWord || "";
  const userEmail = meetingObj.userEmail || "";
  const userName = meetingObj.userName || "";
  const meetingNumber = meetingObj.webinarId || meetingObj.meetingId || "";
  const zakToken = meetingObj.zakToken || "";
  const registrantToken = meetingObj.registrantToken || "";
  const setUrlToLocalStorage = () => {
    window.localStorage.setItem("meetingUrl", window.location.href);
  };

  const startMeeting = () => {
    const zoomTag = document.getElementById("zmmtg-root");
    if (zoomTag) {
      zoomTag.style.display = "block";
    }
    ZoomMtg.init({
      enableFullHD: true,
      enableHD: true,
      leaveUrl: `${APP_BASE_URL}/#/meeting/join?status=non-started`,
      success: () => {
        ZoomMtg.join({
          signature: signature,
          sdkKey: sdkKey,
          meetingNumber: meetingNumber || "",
          passWord: passWord,
          userName: userName,
          userEmail: userEmail,
          ...(zakToken ? { zak: zakToken } : {}),
          ...(registrantToken ? { tk: registrantToken } : {}),
          success: (success: any) => {
            ZoomMtg.showJoinAudioFunction({ show: false });
            const notificationManager = document.getElementById(
              "notificationManager"
            );
            const confirmModalContent = document.getElementsByClassName(
              "confirm-modal-content"
            ) as HTMLCollectionOf<HTMLElement>;
            if (confirmModalContent && confirmModalContent.length > 0) {
              Array.from(confirmModalContent).forEach(
                (item) => (item.style.display = "none")
              );
            }
            if (notificationManager) {
              notificationManager.style.display = "none";
            }
            ZoomMtg.changeRedirectUrl({
              leaveUrl: `${APP_BASE_URL}/#/meeting/end?status=ended` as any,
              success: (data: any) => {},
              error: (error: any) => {
                console.log(error);
              },
            });
          },
          error: (error: any) => {
            console.log(error);
          },
        });
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  };
  React.useEffect(() => {
    startMeeting();
    setUrlToLocalStorage();
  }, []);

  return (
    <>
      <link
        type="text/css"
        rel="stylesheet"
        href="https://source.zoom.us/2.17.0/css/bootstrap.css"
      />
      <link
        type="text/css"
        rel="stylesheet"
        href="https://source.zoom.us/2.17.0/css/react-select.css"
      />
    </>
  );
}

export default ZoomPage;
